module.exports = __webpack_public_path__ + "img/carshina22_02.e05c8040.jpg";